import React from 'react';
import ReactDOM from 'react-dom';
import  styled, { createGlobalStyle } from 'styled-components';
import { useDispatch, useSelector } from "react-redux";
import Header from '../../components/common/header/Header';
import Footer from "../../components/common/Footer";
import LoginPopup, { LoginPopupStyles } from '../../components/common/popup/LoginPopup';
import {Toast, toast} from '../../components/common/noti/Toast'

// import { Redirect, useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import $ from 'jquery';
import {getEventDetailAction, applyEventAction, resetApplyEventAction} from '../../modules/campaign/campaignModule';
import { Helmet } from "react-helmet-async";
import SocialShareBtn from "../../components/common/button/SocialShareBtn"
import moment from 'moment'
import {isMobileOnly} from 'react-device-detect';
import ProdItem from '../../components/common/prod/ProdItem';
import { useHistory, useLocation } from 'react-router-dom';
import { setCurMenuAction, setHeaderTransferAction } from "../../modules/common/headerModule";
import Modal from 'react-modal';
import { brandAction } from '../../modules/su/userBrandModule';
import { setUserBrandAddAction, setUserBrandDelAction } from '../../modules/common/brandModule';
import { applyEvent } from '../../lib/api/campaignapi';

/* 부드러운 스크롤용 */
const SmoothScroll = createGlobalStyle`
  html {
   scroll-behavior: smooth; 
  }
`
/**
 * 이벤트/기획전 페이지 표시용
 */
const socialBarWidth = isMobileOnly?"92vw":"300px";
const socialBtnSize = "40px";
const socialBarBgColor="#ececec";

const ContainerBlock = styled.div`
.video-container {
  position: relative;
  padding-bottom: 56.25%;
  //padding-top: 30px;
  height: 0;
  overflow: hidden;
}
 
.video-container iframe,
.video-container object,
.video-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
   margin-top: ${isMobileOnly?"60px":"80px"};
   
   .event-header {
      max-width:1176px;     
      margin:0 ${isMobileOnly?"4vw":"auto"};
      display:flex;
      justify-content: space-between;
      ${isMobileOnly&&"flex-direction: column"};
      
      ${!isMobileOnly&&`.tag-title {width: 70%;}`};
      ${isMobileOnly&&`
        .tags {max-width:15em;}
        .title {flex:1;}
      `};
      //.period-social {width: 30%;}      
      line-height: 60px;
      border-bottom: 2px solid #111;      
      padding-top: 30px;   /*margin-top이 좀 이상해서 padding-top으로*/
   }
   .tag-future, .tag-past {
      font-size: 15px;
      color: #fc1c67;
      border: 1px dashed #fc1c67;
      border-radius: 10px;
      padding: 4px 10px;
      height: 24px;
      line-height: 15px;
      margin-right: 5px;
      font-weight: normal;
   }
   .tag-title {
        font-size: ${isMobileOnly?"0.9em":"18px"};
        color: #111;
        display: flex;
        justify-content: flex-start;
        .tags {
            display:flex;
            justify-content: flex-start;
            align-items: center;                        
            font-weight: bold;          
            margin-right: 10px;  
            max-width:15em;
            .tag {
              margin-right:6px;
              &:last-of-type {margin-right:0;}
              }
          }
        .title {     
          flex: 1;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;            
        }
      }   
   .period-social {
      display: ${isMobileOnly?"flex":"block"};
      ${isMobileOnly&&`justify-content: space-between;`};
      //width: ${isMobileOnly?"92vw":socialBarWidth};
      flex: 1;
      position: relative;
     .from-to {
       flex: 1;
       font-size:14px;
       color: #999;
       margin-right: calc(${socialBtnSize} + 20px);
       position:${isMobileOnly?"relative":"absolute"};
       right:0;
       .fromto-splitter {margin: 0 6px;}
       }
     .social {
        top: 50%;
        margin-top: calc(${socialBtnSize}/-2);
        margin-left: ${isMobileOnly?"0":`calc(${socialBtnSize}/-2)`};
        //left:0;
        right: 0;
        
     }      
   }
   
   .jump-link {
      &:first-of-type {border-bottom:2px solid #111;}      
      line-height: 60px;
      max-width:1176px;     
      //margin:0 auto;
      display:flex;
      justify-content: flex-start;
      align-items: center;
      i { margin: 0 20px;}
      .tag-title {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;        
                
        .tags {max-width: 15em;}       
        .title {flex:1;}
      }
   }
  
   .mev-input-container {
     width: 70%;
     margin: 0 auto;
     display: block;
     position:relative;
     .mev-input {
       width:100%;
       font-size: ${isMobileOnly?"1em":"1.5em"};
       padding: 10px;
       
       /* chrome, safari, Edge, Opera*/
       &::-webkit-outer-spin-button,
       &::-webkit-inner-spin-button {
         -webkit-appearance: none;
         margin: 0;
       }

       /* Firefox */
       -moz-appearance: textfield;
     }
     
   }
  
  .mev-radio-group {
    margin:3px auto;
    ${isMobileOnly?
    `span {
      input[type="radio"] { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip:rect(0,0,0,0); border: 0; }
      input[type="radio"] + label { display: inline-block; position: relative; padding-left: 30px; cursor: pointer; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; }
      input[type="radio"] + label:before { content: ''; position: absolute; left: 0; top: -4px; width: 20px; height: 20px; text-align: center; background: #fafafa; border: 3px solid #111; border-radius: 100%; }
      input[type="radio"] + label:active:before, .checks input[type="radio"]:checked + label:active:before { box-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px 1px 3px rgba(0,0,0,0.1); }
      input[type="radio"]:checked + label:before { background: #fff; border-color: #111; }
      input[type="radio"]:checked + label:after { content: ''; position: absolute; top: 2px; left: 6px; width: 13px; height: 13px; background: #111; border-radius: 100%; box-shadow: inset 0px 0px 10px rgba(0,0,0,0.3); }
    }`:`
    span {
      input[type="radio"] { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip:rect(0,0,0,0); border: 0; }
      input[type="radio"] + label { display: inline-block; position: relative; padding-left: 50px; cursor: pointer; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; }
      input[type="radio"] + label:before { content: ''; position: absolute; left: 0; top: -4px; width: 40px; height: 40px; text-align: center; background: #fafafa; border: 3px solid #111; border-radius: 100%; box-shadow: 0px 1px 2px rgba(0,0,0,0.05), inset 0px -15px 10px -12px rgba(0,0,0,0.05); }
      input[type="radio"] + label:active:before, .checks input[type="radio"]:checked + label:active:before { box-shadow: 0 1px 2px rgba(0,0,0,0.05), inset 0px 1px 3px rgba(0,0,0,0.1); }
      input[type="radio"]:checked + label:before { background: #fff; border-color: #111; }
      input[type="radio"]:checked + label:after { content: ''; position: absolute; top: 12px; left: 16px; width: 15px; height: 15px; background: #111; border-radius: 100%; box-shadow: inset 0px 0px 10px rgba(0,0,0,0.3); }
    }`};    
    
    label {font-size: ${isMobileOnly?"12px;":"25px;"}
  }
  .clickable {cursor: pointer;}   
`;
const DetailBlock = styled.div`
  width: 100%;
  margin-bottom: 100px;
  margin-top: 20px;
  img {object-fit: cover;}
  
`;
const ProdBlock=styled.div`
    margin:0 ${isMobileOnly?"4vw":"auto"};
    ${!isMobileOnly&&`width: 100%`};
    ${!isMobileOnly&&"max-width: 1176px"}; /* JP for responsive */       
    .item-list {
        display: flex;
        flex-wrap: wrap;
        //justify-content: space-between;
        justify-content: ${isMobileOnly?'space-between':'flex-start'};
        ${isMobileOnly&&"margin-left:0"};
        ${!isMobileOnly&&"margin-left:-28px"};
    }
`;
const SwitcherBlock=styled.div`
      max-width:1176px;     
      margin:0 auto;
      margin-bottom: 160px;
      display:flex;
      flex-direction: column;
      text-overflow: ellipsis;
      justify-content: space-between;
`;

const SendBtnBlock = styled.button`
  position: absolute;
  top: 8px;
  right: 15px;
  width: ${isMobileOnly?"25px":"40px"};
  height: ${isMobileOnly?"25px":"40px"};
  background-image: url(${props => props.img || ''});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

`;


const EventDetail = ({ match }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const [openModal, setOpenModal] = useState(false);
  const [login, setLogin] = useState(false)

  const { status, eventDetail, applyEvent, curMenu, accessToken } = useSelector(
    ({ campaignReducer, headerReducer, userReducer }) => ({
      status: campaignReducer.status,
      eventDetail: campaignReducer.eventDetail,
      applyEvent: campaignReducer.applyEvent,
      accessToken: userReducer.accessToken,
      curMenu: headerReducer.curMenu,
    })
  );
  useEffect(()=>{

    if (!document.getElementById('KakaoJSSDK')) {
      const scriptKakaoJS = document.createElement('script');
      scriptKakaoJS.id = 'KakaoJSSDK';
      scriptKakaoJS.src = '//developers.kakao.com/sdk/js/kakao.min.js';
      document.body.appendChild(scriptKakaoJS);
    }


    (function checkKakao() {
      if (typeof window.Kakao === 'undefined') {
        setTimeout(checkKakao, 500);
      } else {
        window.Kakao.cleanup();
        window.Kakao.init(process.env.REACT_APP_KAKAO_JS);
      }
    })();
  },[]);
  useEffect(() => {
    match&&match.params&&match.params.id&&dispatch(getEventDetailAction(match.params.id))
  }, [dispatch,match]);
  useEffect(() => {

    if (!!accessToken) {
      setLogin(true)
      dispatch(setCurMenuAction('main'));
      setOpenModal(false);
      // if(!!fromLoginPU) setFromLoginPU(false);
    } else {
      setLogin(false)
    }

  }, [accessToken])

  useEffect(()=>{
    if(!!login){
      if(!!accessToken) setOpenModal(false); else setOpenModal(true)
    }
  },[login])

  useEffect(()=>{
    if(!!applyEvent){
      // console.log("applyEvent",applyEvent);
      if(applyEvent.code===200){
        if(applyEvent.type===1||applyEvent.type===4) { // kakao send
          // window.Kakao.cleanup();
          window.Kakao.Link.sendDefault({
            // container: '#${kakaoId}',
            objectType: 'feed',
            content: {
              title: eventDetail.mission.find(o=>o.mission_type===applyEvent.type).placeholder,
              description: eventDetail.mission.find(o=>o.mission_type===applyEvent.type).msg,
              // imageUrl: `${window.location.protocol}//${window.location.hostname}/assets/images/campaign/2021/01/20/kakaoshare_202101ev.png`,
              imageUrl: eventDetail.event_img,
              link: {
                mobileWebUrl: window.location.href,
                webUrl: window.location.href
              }
            },
            buttons: [
              {
                title: eventDetail.mission.find(o=>o.mission_type===applyEvent.type).option_values,
                link: {
                  mobileWebUrl: window.location.href,
                  webUrl: window.location.href,
                },
              }
            ],
            success: function(res){
              console.log('s',res);
            },
            fail: function(res){
              console.log('f',res);
            }
          });
        } else {
          toast("SUCCESS", applyEvent.message);
        }

      } else {
        toast("ERROR", applyEvent.message)
      }

      dispatch(resetApplyEventAction());
    }
  },[JSON.stringify(applyEvent)])

  const apply = (type) =>{
    /*임시*/
    // const val = document.getElementById(`mev-input-${type}`).value;
    if(!login){
      checkLogin();
      return;
    }

    try{
      const val = type===3?document.querySelector(`[name="mev-input-${type}"]:checked`).value:document.querySelector(`[name="mev-input-${type}"]`).value
      // const val = (type===0)?document.getElementById(`mev-input-${type}`).value:"임시";
      if(!val||val.trim()==="") return;
      const data = {
        token: accessToken,
        ev_id: eventDetail.ev_id,
        type: type,
        val: val
      }

      dispatch(applyEventAction(data))

    } catch(e){
      console.log(e);
    }

  }

  useEffect(()=>{
    if(eventDetail&&eventDetail.mission&&eventDetail.mission.length){
      eventDetail.mission.forEach(o=>{
        /* temporary solution for privacy policy */
        // if(window.document.getElementById("ev-mtype-"+o.mission_type)) {
        //   ReactDOM.render(
        //     <div className="mev-input-container">
        //       <input type="number" id={`mev-input-${o.mission_type}`} className="mev-input" onFocus={checkLogin} placeholder={o.placeholder}/>
        //       <SendBtnBlock img="/assets/images/icon/airplane_btn.png" onClick={()=>apply(o.mission_type)}/>
        //     </div>
        //     , document.getElementById("ev-mtype-"+o.mission_type))
        //
        // }

        if(parseInt(o.mission_type) ===0){
          if(window.document.getElementById("ev-mtype-0")) {
            ReactDOM.render(
              <div className="mev-input-container">
                <input type="number" id="mev-input-0" name="mev-input-0" className="mev-input" onFocus={checkLogin} placeholder={o.placeholder}/>
                <SendBtnBlock img="/assets/images/icon/airplane_btn.png" onClick={()=>apply(o.mission_type)}/>
              </div>
              , document.getElementById("ev-mtype-0"))

          }

        } else if(parseInt(o.mission_type) ===1){
          //1
          if(window.document.getElementById("ev-mtype-1")) {
            ReactDOM.render(
              <div className="mev-input-container">
                <button id="mev-input-1" className="mev-input" style={{backgroundColor:"#000", color:"#fff"}} onClick={()=>apply(o.mission_type)}>친구에게 초대장 보내기</button>
                <input name="mev-input-1" type="hidden" value="참여" />
              </div>
              , document.getElementById("ev-mtype-1"))

          }

        } else if(parseInt(o.mission_type) ===3){
          //1
          if(window.document.getElementById("ev-mtype-3")) {
            ReactDOM.render(
              <div className="mev-radio-group flex jse">
                {o.option_values&&o.option_values.split(",").map((v,i)=><span key={i}><input id={`radio${i}`} type="radio" name="mev-input-3" value={v}/><label htmlFor={`radio${i}`}>{v}</label></span>)}
              </div>
              , document.getElementById("ev-mtype-3"))

            document.getElementById("ev-mtype-3-btn").addEventListener("click", ()=>apply(o.mission_type), true);

          }
        } else if(parseInt(o.mission_type) ===4){
          document.getElementById("ev-mtype-4").addEventListener("click", ()=>apply(o.mission_type), true);
        }
      })

    }
  },[eventDetail, accessToken]);

  useEffect(() => {

    if (curMenu !== 'em') {
      //window.scrollTo(0, 0);
      dispatch(setCurMenuAction('em'));
      dispatch(setHeaderTransferAction(false));
  }

    window.onYouTubeIframeAPIReady = () => {
      document.getElementsByClassName("video-player").forEach(v=>{
        const videoId = v.id
        let players = [];
        // `console.log`('video: ',videoId)
        players.push(new window.YT.Player(videoId, {
            width: '100%',
            videoId: videoId,
            playerVars: { 'autoplay': 1, 'playsinline': 1,'modestbranding': 1, 'loop': 1, 'fs': 0, 'disablekb': 1,'controls': 0},
            events: {'onReady': (event)=>{
                event.target.mute();
                event.target.playVideo();
              }}
          }));
      })};
  }, []);

  if(!eventDetail)return(<ContainerBlock/>)

  const checkLogin = () =>{
    //비로그인
    if(!login)setLogin(true)
  }


  const getTitle = (ev) =>`${ev.main_title}`
  const getUrl = (ev) =>`${window.location.protocol}//${window.location.host}/event/${ev.event_cd}`
  const getType = (ev) => "website";
  const getImage = (ev)=>ev.event_img;
  const getMetaTags = ()=>{
    return(
      <Helmet>
        <title>{`어디가구 ${eventDetail.main_title}`}</title>
        <meta property="og:title" content={getTitle(eventDetail)} data-react-helmet={true}/>
        <meta property="og:type" content={getType(eventDetail)} data-react-helmet="true" />
        <meta property="og:url" content={getUrl(eventDetail)} data-react-helmet="true" />
        <meta property="og:image" content={getImage(eventDetail)} data-react-helmet="true" />
        <script src = "https://www.youtube.com/iframe_api" />
      </Helmet>
    )
  };
  const goProduct = (param) => {
    history.push("/prod?prodid=" + param.prdct_id)
  }

  const getTags = (ev)=>(
    // !isMobileOnly&&<div className="tags">
    <div className="tags">
      {/*{moment(ev.start_event_dtm).isAfter(moment())&&<div className="tag-future">시작전</div>}*/}
      {!!ev.end_event_dtm&&moment().isAfter(moment(ev.end_event_dtm).format())&&<div className="tag-past">종료</div>}
      {/*{ev.is_promo===1&&<div className="tag">프로모션</div>}*/}
      {/*{ev.is_sale===1&&<div className="tag">세일</div>}*/}
      {/*{ev.is_brand===1&&<div className="tag">브랜드</div>}*/}
    </div>
  )


  const getTagWithTitle = (ev) =>(
    <div className="tag-title">
      {getTags(ev)}
      <div className="title">{getTitle(ev)}</div>
    </div>
  );
  const getPrevEvent = (ev)=>(
    <a className="jump-link" href={getUrl(ev)}><i className="fas fa-chevron-up"/>{getTagWithTitle(ev)}</a>
  )
  const getNextEvent = (ev)=>(
    <a className="jump-link" href={getUrl(ev)}><i className="fas fa-chevron-down"/>{getTagWithTitle(ev)}</a>
  )

  if (!eventDetail) {
    return <div />;
  }

    return (
      <ContainerBlock>
        <SmoothScroll />
        {getMetaTags()}
        <Header />
      <div className="event-header">
        {getTagWithTitle(eventDetail)}
        <div className="period-social">
          <div className="from-to">
            <span>{moment(eventDetail.start_event_dtm).format('YYYY-MM-DD')}</span><span className="fromto-splitter">~</span><span>{eventDetail.end_event_dtm&&`${moment(eventDetail.end_event_dtm).format('YYYY-MM-DD')}`}</span>
        </div>
          <SocialShareBtn className="social"
                          pageTitle={getTitle(eventDetail)} url={getUrl(eventDetail)} type={getType(eventDetail)} image={getImage(eventDetail)}
                          btnSize={socialBtnSize} barWidth={socialBarWidth} bgColor={socialBarBgColor}/>
        </div>
      </div>
        <DetailBlock>
          <div dangerouslySetInnerHTML={{ __html: eventDetail.event_detail }}/>
        </DetailBlock>
        <ProdBlock>
          <div className="default-section">
            <ul className="item-list clearfix">
              {
                eventDetail.products&&eventDetail.products.map((curitem) => {
                  return (<ProdItem
                    key={curitem.prdct_id}
                    img={curitem.repr_img}
                    prodname={curitem.prdct_nm}
                    sale_price={curitem.sale_price}
                    prdct_price={curitem.prdct_price}
                    brandname={curitem.brnd_han}
                    isBrandShow={true}
                    clickHandler={goProduct}
                    brandid={curitem.brnd_id}
                    prodinfo={curitem} />)
                })
              }
              {isMobileOnly ? <div style={{height:'0px', margin: '0px', width:'44vw'}}></div> : ''}
            </ul>
          </div>
        </ProdBlock>
        <SwitcherBlock>
          {eventDetail.prev&&getPrevEvent(eventDetail.prev)}
          {eventDetail.next&&getNextEvent(eventDetail.next)}
        </SwitcherBlock>
        <Footer />
        <Modal
          isOpen={openModal}
          style={LoginPopupStyles}>
          <LoginPopup onClosePopup={() => { setOpenModal(false) }}/>
        </Modal>
        <Toast />
      </ContainerBlock>
    );
};

export default EventDetail;
